import React, { PureComponent } from "react";
import { Button, Image } from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";
import { PATHS, STATUS, ISSUE_STATUS } from "../../constant";
import IssueActions from "./IssueActions";
import ProjectOverview from "../projectDetails/ProjectOverview";
import IconTime from "../../assets/icon-time.svg";
import PointingArrow from "../../assets/pointing-arrow.svg";
import NewPencilIcon from "../../assets/Union.svg";
import {
  dateFormat,
  isValidArray,
  getColor,
  formatNumber,
  dayAgo,
  transformProjectCategoryId,
  modifyDataOfAddIssue
} from "../../helper";
import EditIssue from "../createProjectAddIssueForm/EditIssue";
import { connect } from "react-redux";
import { get } from "lodash";
import {
  issueActivityComment,
  issueActivityHistory
} from "../../actions/issueDetail.action";
import { bindActionCreators } from "redux";
import ForwardToTeamChilds from "../issueList/forwardToTeamChilds";
import HistoryAndCommentLoader from "../IssueHistoryAndComments/History";
import { getIssueList } from "../../actions/common.action";
import { getActions } from "../../actions/issuesListAction.actions";
import DisplayByPermission from "../../component/DisplayByPermission";
import { ComponentLoader } from "../../component/ComponentLoader";
import { LoaderPage } from "../../component/Loader";
import { DisplayContent } from "../displayContent";
import { Pli } from "../pliReview";
import { Pragati } from "../prgatiReview";
import { Nip } from "../nipReview";
import { ReadMore, PreNode, RedirectUser } from "../reusableComponent";
import {
  getIssueAssigneeDate,
  getIssueStatus,
  shouldDisplayIssueAction,
  toolttipDisplayMessage
} from "./helper";
import { PmFoundationStone } from "../pmFoundationStone/pmFoundationStone";
import { CmPragatiYatra } from "../cmPragatiYatra/cmPragatiYatra";
import { CmFoundationStone } from "../cmFoundationStone/cmFoundationStone";
import HistoryAndCommentModal from "./historyAndCommentModal";
//import { PmGatiShakti } from "../pmGatiShakti/pmGatiShakti";
import { PmgsHipimage } from "../pmgsHipp/pmgsHip";
import { PmGatiShakti } from "../pmGatiShakti/pmGatiShakti";
import htmlToFormattedText from "html-to-formatted-text";
import { March24 } from "../march24";
import Comment from "../IssueHistoryAndComments/Comment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import IssueUpdateStatus from "./IssueUpdateStatus";
import MarkDuplicatebtn from "../issueDetail/MarkDuplicatebtn";
import { getPermissionsListing } from "../../services/apiServices";
import request from "../../services/requestService";
import { EscalationLevelModal } from "../reusableComponent/EscalationLevel/EscalationLevelModal";
import IssuePragatiLogo from "./../../assets/issue_pragati_review.svg";
import IssuePragatiReview from "../prgatiReview/IssuePragatiReview";
import AgendaIssuePragatiReview from "../prgatiReview/AgendaIssuePragatiReview";
import ReadMoreHTML from "../readMoreHtml";
import { DisplayHtmlContent } from "../displayHtmlContent";
import { ReadMoreContent } from "../reusableComponent/readMore/readMoreContent";
import PariveshData from "../pariveshData";
import { PragatiPipeline } from "../prgatiReview/pragatiPipeline";
import AgendaIssuePragatiPipeline from "../prgatiReview/AgendaIssuePragatiPipeline";
const MESSAGES_CONSTANT = {
  EditIssue: "Edit issue details"
};
export const issueListParams = {
  limit: 10,
  offset: 0,
  sortBy: "CREATED_DATE",
  sortOrder: "DESC"
};
const ToolTip = ({
  text,
  children,
  id,
  containerClass,
  placement = "bottom"
}) => {
  return (
    <OverlayTrigger
      defaultShow={false}
      placement={placement}
      overlay={
        <Tooltip id={id} className={`issues-actions-tooltip ${containerClass}`}>
          {text || null}
        </Tooltip>
      }
    >
      {children}
    </OverlayTrigger>
  );
};
class IssueTile extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      type: "comment",
      issueHistory: false,
      issueHistoryResponsive: false,
      issueAction: false,
      history: [],
      show: false,
      displayButtons: 0,
      backgroundcolor: "white",
      markbtndisplay: 0,
      admincredential: true,
      isPariveshModalVisible: false,
      selectedIssueSubCategoryId: null,
      selectedProposalNoParivesh: null,
      isProposalValidated: false
    };
  }
  handleMarkBTN = data => {
    this.setState({ markbtndisplay: data });
  };
  handleButtonClose = data => {
    this.setState({ displayButtons: data });
  };
  componentDidMount = async () => {
    const response = await request(getPermissionsListing());
    const data = response.data.data.find(
      item => item.name === "updateProjectStatus"
    );
    if (data == undefined) {
      this.setState({ admincredential: true });
    } else if (data.name == "updateProjectStatus") {
      //console.log(data.name=="updateProjectStatus")
      this.setState({ admincredential: false });
    } else {
      this.setState({ admincredential: true });
    }
    //console.log(data.name=="admin")
  };
  componentWillReceiveProps(nextProps) {
    const { issueDetails } = this.props;
    if (get(issueDetails, "id") !== get(nextProps, "issueDetails.id")) {
      this.setState({
        issueAction: false
      });
    }
  }

  handleClose = () => {
    this.setState({ show: false });
  };

  handleShow = e => {
    localStorage.setItem("DisplayButton", "0");
    e.stopPropagation();
    e.preventDefault();
    this.setState({
      show: true
    });
  };

  // toggleIssueHistory = (e, type) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   this.setState(
  //     {
  //       history: [],
  //       comment: [],
  //       isHistoryLoading: STATUS.LOADING,
  //       type
  //     },
  //     async () => {
  //       const {
  //         issueDetails,
  //         issueActivityHistoryDispatch,
  //         issueActivityCommentDispatch,
  //         permission
  //       } = this.props;

  //       if (issueDetails) {
  //         const api =
  //           type === "comment"
  //             ? issueActivityCommentDispatch
  //             : issueActivityHistoryDispatch;

  //         const getDataOfIds = [{ issueId: get(issueDetails, "id") }].concat(
  //           issueDetails.childs.map(value => {
  //             return { issueId: value.id };
  //           })
  //         );

  //         const idsOfIssuesWithDuplicateIssues = (getDataOfIds || []).concat(
  //           issueDetails.duplicateIssues &&
  //             issueDetails.duplicateIssues.length &&
  //             issueDetails.duplicateIssues.map(value => {
  //               return { issueId: value };
  //             })
  //         );
  //         Promise.all(
  //           idsOfIssuesWithDuplicateIssues.map(value => {
  //             return api(undefined, value);
  //           })
  //         ).then(resp => {
  //           const extractData = resp.map((value, index) => {
  //             if (value.status) {
  //               value.data.forEach(comments => {
  //                 comments.issueId =
  //                   idsOfIssuesWithDuplicateIssues[index]["issueId"];
  //                 if (
  //                   issueDetails &&
  //                   issueDetails.duplicateIssues &&
  //                   issueDetails.duplicateIssues.length
  //                 ) {
  //                   comments.isIssueDuplicate = issueDetails.duplicateIssues.includes(
  //                     idsOfIssuesWithDuplicateIssues[index]["issueId"]
  //                   );
  //                 }
  //               });
  //               return value.data;
  //             }
  //           });
  //           this.setState({
  //             isHistoryLoading: STATUS.SUCCESS,
  //             [type]: extractData
  //           });
  //         });
  //       }
  //       //}
  //     }
  //   );
  // };
  toggleIssueHistory = (e, type) => {
    e.preventDefault();
    e.stopPropagation();
    this.fetchIssueHistory(type);
  };

  // New: same logic, no event required — safe to call from anywhere (e.g. after Approve)
  fetchIssueHistory = (type = "comment") => {
    this.setState(
      {
        history: [],
        comment: [],
        isHistoryLoading: STATUS.LOADING,
        type
      },
      async () => {
        const {
          issueDetails,
          issueActivityHistoryDispatch,
          issueActivityCommentDispatch
        } = this.props;

        if (issueDetails) {
          const api =
            type === "comment"
              ? issueActivityCommentDispatch
              : issueActivityHistoryDispatch;

          const getDataOfIds = [{ issueId: get(issueDetails, "id") }].concat(
            issueDetails.childs.map(value => ({ issueId: value.id }))
          );

          const idsOfIssuesWithDuplicateIssues = (getDataOfIds || []).concat(
            issueDetails.duplicateIssues &&
              issueDetails.duplicateIssues.length &&
              issueDetails.duplicateIssues.map(value => ({ issueId: value }))
          );

          Promise.all(
            idsOfIssuesWithDuplicateIssues.map(value => api(undefined, value))
          ).then(resp => {
            const extractData = resp.map((value, index) => {
              if (value.status) {
                value.data.forEach(comments => {
                  comments.issueId =
                    idsOfIssuesWithDuplicateIssues[index]["issueId"];
                  if (
                    issueDetails &&
                    issueDetails.duplicateIssues &&
                    issueDetails.duplicateIssues.length
                  ) {
                    comments.isIssueDuplicate = issueDetails.duplicateIssues.includes(
                      idsOfIssuesWithDuplicateIssues[index]["issueId"]
                    );
                  }
                });
                return value.data;
              }
            });
            this.setState({
              isHistoryLoading: STATUS.SUCCESS,
              [type]: extractData
            });
          });
        }
      }
    );
  };
  toggleIssueActions = (e, issueDetail) => {
    e.preventDefault();
    e.stopPropagation();
    const { issueAction } = this.state;
    const { getActionsDispatch } = this.props;

    this.setState(
      {
        actionsData: null,
        issueAction: !issueAction,
        isActionLoading: STATUS.LOADING
      },
      async () => {
        const response =
          !issueAction &&
          get(issueDetail, "id") &&
          (await getActionsDispatch(undefined, get(issueDetail, "id")));
        if (response) {
          const { data, status } = response;
          this.setState({
            actionsData: data,
            isActionLoading: (status && STATUS.SUCCESS) || STATUS.ERROR
          });
        }
      }
    );
  };
  onToogleProgressTimeLine = e => {
    const { issueHistory } = this.state;
    this.setState(
      {
        issueHistory: !issueHistory,
        type: "comment"
      },
      () => {
        this.state.issueHistory && this.toggleIssueHistory(e, "comment");
      }
    );
  };

  onToogleProgressTimeLineResponsive = e => {
    const { issueHistoryResponsive } = this.state;
    this.setState(
      {
        issueHistoryResponsive: !issueHistoryResponsive,
        type: "comment"
      },
      () => {
        this.state.issueHistoryResponsive &&
          this.toggleIssueHistory(e, "comment");
      }
    );
  };

  showPraiveshModal = () => {
    //const { issueData } = this.state;
    const { issueDetails } = this.props;
    console.log(issueDetails);
    //let data = get(issueData, "data", null);
    const issueSubcategoryId = get(issueDetails, "subCategoryId", null);
    const proposalNoParivesh = get(issueDetails, "proposalNoParivesh", null);
    this.setState({
      isPariveshModalVisible: true,
      selectedIssueSubCategoryId: issueSubcategoryId,
      selectedProposalNoParivesh: proposalNoParivesh
    });
  };
  closePariveshModal = () => {
    this.setState({
      isPariveshModalVisible: false
    });
  };

  handleProposalChange = proposal => {
    this.setState({ isProposalValidated: proposal });
  };

  render() {
    const {
      issueHistory,
      issueAction,
      show,
      type,
      history,
      comment,
      isHistoryLoading,
      actionsData,
      animationEnded,
      isActionLoading,
      issueHistoryResponsive,
      isPariveshModalVisible
    } = this.state;
    const {
      issueDetails,
      paginationNo,
      callApiOnSuccess,
      filterArray,
      permission,
      projectIssues,
      isIssueList
    } = this.props;

    const isPragatiReview = get(issueDetails, "issuePragatiReview");
    const isPragatiPipeline = get(issueDetails, "issuePragatiPipeLine");

    let displayActions = shouldDisplayIssueAction(actionsData);
    const projectCost = formatNumber(
      get(issueDetails, "project.revisedCost", 0) ||
        get(issueDetails, "project.totalCost", "0")
    );

    const isIssueListPhysicalProgress =
      get(issueDetails, "project.projectCompletionDTO") &&
      get(issueDetails, "project.projectCompletionDTO.percentage");

    const isFlagListPhysicalProgress =
      !isIssueListPhysicalProgress &&
      !get(issueDetails, "project.pragatiReview") &&
      !get(issueDetails, "project.nipReview") &&
      !get(issueDetails, "project.pmFoundationStone") &&
      !get(issueDetails, "project.cmPragatiYatra") &&
      !get(issueDetails, "project.cmFoundationStone") &&
      !get(issueDetails, "project.pmGatiShakti") &&
      !get(issueDetails, "project.pli");

    // const filteredProjectPPList = get(
    //   issueDetails,
    //   "project.projectPPList",
    //   []
    // ).filter(ppItem => ppItem.name == get(issueDetails, "creatorName", "NA"));
    //console.log("issueDetails", issueDetails);
    return (
      <React.Fragment>
        <div
          className={`${
            issueHistory
              ? "issue-list-box-wrapper show-activity"
              : "issue-list-box-wrapper"
          }`}
        >
          <div className="issue-list-box">
            <div className="issue-list-box-top">
              <div className="issue-id-box">
                ISSUE {/**CR 99 Changes Starts */}
                {get(issueDetails, "isUserOfGroup") ? (
                  <>
                    <Link
                      to={{
                        pathname: PATHS.ISSUE_DETAIL,
                        search: `?issueId=${get(
                          issueDetails,
                          "id"
                        )}&&projectId=${get(issueDetails, "project.id")}`
                      }}
                    >
                      #{get(issueDetails, "project.displayId")}-
                      {get(issueDetails, "parentId")}
                      {get(issueDetails, "parentId") !== null && <span>/</span>}
                      {get(issueDetails, "id", "NA")}
                    </Link>
                  </>
                ) : (
                  <>
                    <Link
                      to={{
                        pathname: PATHS.ISSUE_DETAIL,
                        search: `?issueId=${get(
                          issueDetails,
                          "id"
                        )}&&projectId=${get(issueDetails, "project.id")}`
                      }}
                    >
                      #{get(issueDetails, "project.displayId")}-
                      {get(issueDetails, "id", "NA")}
                    </Link>
                  </>
                )}
                {/**CR 99 Changes Ends */}
                {/**CR 289 Changes Starts-Yajnadutta */}
                {get(issueDetails, "escalationLevelName", "NA") ==
                null ? null : (
                  <EscalationLevelModal
                    IssueId={get(issueDetails, "id")}
                    EscalationName={get(
                      issueDetails,
                      "escalationLevelName",
                      "NA"
                    )}
                  />
                )}
                {/**CR 289 Changes End-Yajnadutta */}
              </div>
              <OverlayTrigger
                defaultShow={false}
                trigger="hover"
                placement="top"
                overlay={
                  <Tooltip className="issues-status-tooltip ">
                    {toolttipDisplayMessage(get(issueDetails, "status", "NA"))}
                  </Tooltip>
                }
              >
                <div className="issue-stage-box">
                  <Button
                    className={`btn-extra-small animated flipInX ${getColor(
                      get(issueDetails, "status", "NA").toLowerCase()
                    )} unClickable`}
                  >
                    {get(issueDetails, "status", "NA")}
                  </Button>
                </div>
              </OverlayTrigger>
            </div>
            <div
              className={`issue-list-box-middle ${
                isValidArray(get(issueDetails, "childs"))
                  ? "apply-data-lines-middle-box"
                  : ""
              }`}
            >
              <div className="issue-list-box-middle-left">
                <div
                  className={`issue-list-box-title-wrapper ${
                    issueHistory ? "set-width" : ""
                  }`}
                >
                  <h2>
                    <Link
                      to={{
                        pathname: PATHS.ISSUE_DETAIL,
                        search: `?issueId=${get(
                          issueDetails,
                          "id"
                        )}&&projectId=${get(issueDetails, "project.id")}`
                      }}
                    >
                      <ReadMore
                        clamp={2}
                        displayExpandButtons={false}
                        content={htmlToFormattedText(
                          get(issueDetails, "title", "NA")
                        )}
                        lineHeightTitle={1.3}
                      />
                    </Link>
                  </h2>
                </div>
                <div>
                  {get(issueDetails, "childIssue") === true &&
                    get(issueDetails, "issueForwardedById") !== null && (
                      <div className="pt-2 pb-3">
                        <img src={PointingArrow} />{" "}
                        <span className="creator-text">Forwarded by</span>{" "}
                        <RedirectUser
                          title={get(
                            issueDetails,
                            "issueForwardedByName",
                            "NA"
                          )}
                          id={get(issueDetails, "issueForwardedById", "NA")}
                          isIssueForwarded={true}
                          isMilestonePPDetail={true}
                        />{" "}
                        <span className="creator-text">
                          on{" "}
                          {dateFormat(get(issueDetails, "createdDate", null))}
                        </span>
                      </div>
                    )}
                </div>
                <div
                  className="issue-detail-unit-wrapper"
                  style={{
                    lineHeight:
                      get(issueDetails, "project.sponsoredByCategory") !=
                        "CENTRAL" &&
                      /[\u0900-\u097F]/.test(
                        get(issueDetails, "responsibleAuthority") || ""
                      )
                        ? "18px"
                        : ""
                  }}
                >
                  <div className="issue-detail-unit">
                    <span style={{ fontFamily: "mpb", minWidth: "201.5px" }}>
                      Recipient{" "}
                      {transformProjectCategoryId(
                        get(issueDetails, "recipientGroupCategory")
                      )}
                      :
                    </span>
                    <div
                      className="responsible-div"
                      style={{
                        color: "#E65A32"
                        // marginLeft:
                        //   get(issueDetails, "childIssue") === true
                        //     ? "8px"
                        //     : "17px"
                      }}
                    >
                      {" "}
                      {get(issueDetails, "recipientGroup")}
                    </div>
                  </div>
                  {get(issueDetails, "districtName") ? (
                    <div className="issue-detail-unit">
                      <span style={{ fontFamily: "mpb" }}>
                        {get(issueDetails, "recipientLabel")}:{" "}
                      </span>
                      <div
                        className="responsible-div"
                        style={{ color: "#E65A32", marginLeft: "16px" }}
                      >
                        {get(issueDetails, "districtName")}
                      </div>
                    </div>
                  ) : null}
                  {get(issueDetails, "responsibleAuthority") ? (
                    <div className="issue-detail-unit">
                      <span style={{ fontFamily: "mpb" }}>
                        Responsible Authority:{" "}
                      </span>
                      <div
                        className={`responsible-div 
                          ${
                            get(
                              issueDetails,
                              "responsibleAuthority",
                              "NA"
                            ).match(/[\u0900-\u097F]/)
                              ? "hindi-text-wrap"
                              : ""
                          }`}
                        style={{
                          color: "#E65A32",
                          marginLeft: "16px"
                        }}
                      >
                        {htmlToFormattedText(
                          get(issueDetails, "responsibleAuthority", "NA")
                        )}
                      </div>
                    </div>
                  ) : null}
                  {get(issueDetails, "secondaryState") ||
                  get(issueDetails, "secondaryRecipientGroupName") ? (
                    <div className="issue-detail-unit">
                      <span style={{ fontFamily: "mpb" }}>
                        Secondary Recipient:{" "}
                      </span>
                      <div
                        className="responsible-div"
                        style={{ color: "#E65A32", marginLeft: "16px" }}
                      >
                        {htmlToFormattedText(
                          get(issueDetails, "secondaryState", "NA") ||
                            get(issueDetails, "secondaryRecipientGroupName")
                        )}
                      </div>
                    </div>
                  ) : get(issueDetails, "secondaryMinistry") ? (
                    <div className="issue-detail-unit">
                      <span style={{ fontFamily: "mpb" }}>
                        Secondary Recipient:{" "}
                      </span>
                      <div
                        className="responsible-div"
                        style={{ color: "#E65A32", marginLeft: "16px" }}
                      >
                        {htmlToFormattedText(
                          get(issueDetails, "secondaryMinistry", "NA")
                        )}
                      </div>
                    </div>
                  ) : null}
                  {/* {console.log(issueDetails)} */}
                  {get(issueDetails, "project.sponsoredByCategory") ==
                  "STATE" ? null : (
                    <div className="issue-detail-unit">
                      <span>Issue Location: </span>
                      <div style={{ marginLeft: "16px" }}>
                        {get(issueDetails, "centerState")}
                      </div>
                    </div>
                  )}
                  {/* {get(issueDetails, "centerState") ? (
                    <div className="issue-detail-unit">
                      <span>Issue Location: </span>
                      <div style={{ marginLeft: "16px" }}>
                        {get(issueDetails, "centerState")}
                      </div>
                    </div>
                  ) : null} */}
                  {get(issueDetails, "centerDistrict") ? (
                    <div className="issue-detail-unit">
                      {get(issueDetails, "recipientGroupCategory") ==
                        "CENTRAL" ||
                      get(issueDetails, "recipientGroupCategory") ==
                        "CENTRAL_DEPARTMENT" ||
                      get(issueDetails, "recipientGroupCategory") == "OTHER" ? (
                        <span>Issue District:</span>
                      ) : (
                        <span>Issue District/Department:</span>
                      )}
                      <div style={{ marginLeft: "16px" }}>
                        {get(issueDetails, "centerDistrict")}
                      </div>
                    </div>
                  ) : null}
                  <div className="issue-detail-unit">
                    <span> Issue Category: </span>
                    <div style={{ marginLeft: "16px" }}>
                      {get(issueDetails, "category", "NA")}
                    </div>
                  </div>
                  {get(issueDetails, "subCategory") ? (
                    <div className="issue-detail-unit">
                      <span>Issue Sub-Category: </span>
                      <div style={{ marginLeft: "16px" }}>
                        {get(issueDetails, "subCategory", "NA")}
                      </div>
                    </div>
                  ) : null}
                  {get(issueDetails, "bucket.name") ? (
                    <div className="issue-detail-unit">
                      <span>Project Stage: </span>
                      <div style={{ marginLeft: "16px" }}>
                        {get(issueDetails, "bucket.name", "NA")}
                      </div>
                    </div>
                  ) : null}
                  {get(issueDetails, "milestoneTable.name") ? (
                    <div className="issue-detail-unit">
                      <span>Phase: </span>
                      <div style={{ marginLeft: "16px" }}>
                        {get(issueDetails, "milestoneTable.name", "NA")}
                        {get(issueDetails, "phaseName") ? " - " : ""}
                        {get(issueDetails, "phaseName", "")}
                      </div>
                    </div>
                  ) : null}
                  {get(issueDetails, "milestone.name") ? (
                    <div className="issue-detail-unit">
                      <span>Milestone: </span>
                      <div style={{ marginLeft: "16px" }}>
                        {get(issueDetails, "milestone.name", "NA")}
                      </div>
                    </div>
                  ) : null}

                  {get(issueDetails, "proposalNoParivesh") ? (
                    <div className="issue-detail-unit">
                      <span>Proposal No. (PARIVESH):</span>
                      <div
                        style={{ marginLeft: "16px" }}
                        className="proposal-link"
                        onClick={this.showPraiveshModal}
                      >
                        {get(issueDetails, "proposalNoParivesh", "NA")}
                      </div>
                    </div>
                  ) : null}
                  {get(issueDetails, "forum") ? (
                    <div className="issue-detail-unit">
                      <span>Forum: </span>
                      <div style={{ marginLeft: "16px" }}>
                        {get(issueDetails, "forum.name", "NA")}
                      </div>
                    </div>
                  ) : null}
                  {get(issueDetails, "dateOfOrder") ? (
                    <div className="issue-detail-unit">
                      <span>Date of Order: </span>
                      <div style={{ marginLeft: "16px" }}>
                        {dateFormat(get(issueDetails, "dateOfOrder", null))}
                      </div>
                    </div>
                  ) : null}
                </div>

                <div className="issue-list-box-desc">
                  {/* <PreNode>
                    <ReadMore
                      clamp={3}
                      content={get(issueDetails, "description")}
                      descriptionWeight={true}
                    />
                  </PreNode> */}
                  <PreNode>
                    <ReadMoreContent
                      clamp={3}
                      content={get(issueDetails, "description")}
                      descriptionWeight={true}
                    />
                  </PreNode>
                </div>

                {(get(issueDetails, "latestIssueComments") && (
                  <div className="latest-comment-box">
                    <div className="issue-list-box-comment-heading">
                      <h3>Latest Comment by:</h3>
                      <span style={{ "margin-left": "5px" }}>
                        <span>
                          {get(issueDetails, "latestIssueComments").createdBy}
                        </span>{" "}
                        |
                        <span>
                          {get(issueDetails, "latestIssueComments") &&
                            dateFormat(
                              get(issueDetails, "latestIssueComments")
                                .createdDate
                            )}
                        </span>
                      </span>
                    </div>
                    {/* <DisplayContent
                      classes={`issue-list-box-desc ${
                        get(issueDetails, "latestIssueComments.comment").match(
                          /[\u0900-\u097F]/
                        )
                          ? "hindi-text-no-weight"
                          : ""
                      }`}
                      showCreatedInfo={false}
                      content={get(issueDetails, "latestIssueComments")}
                    /> */}
                    <DisplayHtmlContent
                      classes={`issue-list-box-desc ${
                        get(issueDetails, "latestIssueComments.comment").match(
                          /[\u0900-\u097F]/
                        )
                          ? "hindi-text-no-weight"
                          : ""
                      }`}
                      showCreatedInfo={false}
                      content={get(issueDetails, "latestIssueComments")}
                    />
                  </div>
                )) ||
                  null}
              </div>
              <div className="issue-list-box-middle-right">
                <div className="issue-list-box-middle-right-section">
                  <div className="issue-list-box-status-wrapper">
                    {getIssueStatus(issueDetails)}
                  </div>

                  <div className="issue-list-box-assign-date">
                    <Image src={IconTime} alt="Time" />
                    <span>{getIssueAssigneeDate(issueDetails)}</span>
                  </div>

                  <div className="issue-list-actions">
                    <div className="issue-list-actions-btns">
                      {/* <DisplayByPermission
                        display={
                          issueAction &&
                          get(actionsData, "edit") &&
                          get(issueDetails, "projectIssueDTO.status") !==
                            "ON_HOLD" &&
                          get(issueDetails, "projectIssueDTO.status") !==
                            "REJECTED"
                        }
                      >
                        <Button className="edit-btn" onClick={this.handleShow}>
                          Edit
                        </Button>
                      </DisplayByPermission> */}
                      {issueAction ? (
                        <LoaderPage
                          loading={isActionLoading === STATUS.LOADING}
                        />
                      ) : null}
                      <Button
                        className={`btn-orange-invert btn-small btn-right-arrow progress-timeline-btn ${
                          issueHistory ? `history-visible` : ""
                        }`}
                        onClick={this.onToogleProgressTimeLine}
                      >
                        <span>Progress Timeline</span>
                      </Button>
                      <Button
                        className={`btn-orange-invert btn-small btn-right-arrow progress-timeline-resp-btn ${
                          issueHistoryResponsive ? `history-visible` : ""
                        }`}
                        onClick={this.onToogleProgressTimeLineResponsive}
                      >
                        <span>Progress Timeline</span>
                      </Button>
                      <DisplayByPermission
                        display={
                          get(issueDetails, "projectIssueDTO.status") !==
                            "ON_HOLD" &&
                          get(issueDetails, "projectIssueDTO.status") !==
                            "REJECTED" &&
                          !get(permission, "canViewOnlyIssues")
                        }
                      >
                        <Button
                          className={`btn-orange-invert btn-small btn-down-arrow ${
                            issueAction && issueDetails
                              ? `activity-visible`
                              : ""
                          }`}
                          onClick={e => {
                            this.toggleIssueActions(e, issueDetails);
                          }}
                        >
                          <span>Actions</span>
                        </Button>
                      </DisplayByPermission>
                    </div>
                  </div>
                </div>

                <div className="issue-list-created-date mt-2">
                  {/* <AgendaIssuePragatiReview
                    isPragati={get(issueDetails, "issuePragatiReview")}
                    className="issue__list_pragati_flag"
                  /> */}
                  {isPragatiReview ? (
                    <AgendaIssuePragatiReview
                      isPragati={isPragatiReview}
                      className="issue__list_pragati_flag"
                    />
                  ) : isPragatiPipeline ? (
                    <AgendaIssuePragatiPipeline
                      isPragatiPipeline={isPragatiPipeline}
                      className="issue__list_pipeline_flag"
                    />
                  ) : null}
                  <div style={{ display: "flex", width: "max-content" }}>
                    <div
                      className="issue-list-created-by d-flex justify-content-end"
                      style={{ alignItems: "end", paddingRight: "10px" }}
                    >
                      <div
                        className={`issue-created-by
                      ${get(issueDetails, "creatorVerified") &&
                        "verified-user"}`}
                      >
                        <RedirectUser
                          title={get(issueDetails, "creatorName", "NA")}
                          id={get(issueDetails, "createdById", "NA")}
                        />
                      </div>
                    </div>
                    <span className="issue-created-on">
                      {get(issueDetails, "verificationDate")
                        ? `Verified on
                                        ${dateFormat(
                                          get(
                                            issueDetails,
                                            "verificationDate",
                                            null
                                          )
                                        )}`
                        : `
                                        Created on
                                        ${dateFormat(
                                          get(issueDetails, "createdDate", null)
                                        )}
                                     `}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <DisplayByPermission
              display={issueAction && issueDetails && displayActions}
            >
              <div
                className={`issue-actions issue-list-action ${
                  isValidArray(get(issueDetails, "childs"))
                    ? "apply-data-lines-action-box"
                    : ""
                }`}
              >
                <IssueActions
                  isLoading={isActionLoading}
                  issueDetails={{ ...issueDetails, ...actionsData }}
                  paginationNo={paginationNo}
                  resetAction={this.toggleIssueActions}
                  callApiOnSuccess={callApiOnSuccess}
                  filterArray={filterArray}
                  onCloseButton={this.handleButtonClose}
                  markDuplicateBTN={this.state.markbtndisplay}
                  isIssueList={isIssueList}
                />
                <DisplayByPermission
                  display={
                    issueAction &&
                    get(actionsData, "edit") &&
                    get(issueDetails, "projectIssueDTO.status") !== "ON_HOLD" &&
                    get(issueDetails, "projectIssueDTO.status") !== "REJECTED"
                  }
                >
                  <ToolTip text={MESSAGES_CONSTANT["EditIssue"]}>
                    <Button
                      style={{
                        display: this.state.displayButtons == 1 ? "none" : null
                      }}
                      className={`new-editdecision-btn no-padding shadow-none align-self-end`}
                      onClick={this.handleShow}
                    >
                      <img src={NewPencilIcon} className="newpencilicon" /> Edit
                      Issue
                    </Button>
                  </ToolTip>
                </DisplayByPermission>

                <IssueUpdateStatus
                  isLoading={isActionLoading}
                  issueDetails={{ ...issueDetails, ...actionsData }}
                  paginationNo={paginationNo}
                  resetAction={this.toggleIssueActions}
                  callApiOnSuccess={callApiOnSuccess}
                  filterArray={filterArray}
                  Displaybuttons={this.state.displayButtons}
                  BackgroundColor={this.state.backgroundcolor}
                  onCloseButton={this.handleButtonClose}
                  markDuplicateBTN={this.handleMarkBTN}
                  issueStatus={
                    issueDetails.project.status == "ON_HOLD" ||
                    issueDetails.status == "Rejected"
                      ? true
                      : false
                  }
                  marginleft={true}
                  AdminCredential={this.state.admincredential}
                />
                {/* <MarkDuplicatebtn
               isLoading={isActionLoading}
               issueDetails={{ ...issueDetails, ...actionsData }}
               paginationNo={paginationNo}
               resetAction={this.toggleIssueActions}
               callApiOnSuccess={callApiOnSuccess}
               filterArray={filterArray}
               Displaybuttons={this.state.displayButtons}
               onCloseButton={this.handleButtonClose}
               markDuplicateBTN={this.handleMarkBTN}
               /> */}
              </div>
            </DisplayByPermission>

            <DisplayByPermission
              display={isValidArray(get(issueDetails, "childs"))}
            >
              <div className="forwarded-to-team">
                <ForwardToTeamChilds
                  childs={get(issueDetails, "childs")}
                  issueDetails={issueDetails}
                />
              </div>
            </DisplayByPermission>
            <div className="issue-list-box-bottom">
              <div className="issue-list-box-bottom-div">
                <ProjectOverview
                  data={get(issueDetails, "project", "NA")}
                  parentClass={"project-overview-common"}
                  fontSize="20px"
                  issueTile={false}
                />
                <div className="d-flex progress-wrapeer justify-content-between">
                  {isIssueListPhysicalProgress ? (
                    <div className="physical-progress-wrapper issue-progress-wrapper">
                      <div className="progress-upper d-flex align-items-center fw-bold">
                        Physical Progress:{" "}
                        <span className="d-inline-block">
                          {get(
                            issueDetails,
                            "project.projectCompletionDTO.percentage"
                          )}
                          %
                        </span>
                      </div>
                      {get(
                        issueDetails,
                        "project.projectCompletionDTO.physicalProgressAsOf"
                      ) ? (
                        <div className="progress-lower">
                          (as of{" "}
                          {dateFormat(
                            get(
                              issueDetails,
                              "project.projectCompletionDTO.physicalProgressAsOf"
                            )
                          )}
                          )
                        </div>
                      ) : get(
                          issueDetails,
                          "project.projectCompletionDTO.date"
                        ) ? (
                        <div className="progress-lower">
                          (as of{" "}
                          {dateFormat(
                            get(
                              issueDetails,
                              "project.projectCompletionDTO.date"
                            )
                          )}
                          )
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  <div
                    className={`${
                      isIssueListPhysicalProgress
                        ? "issue-list-project-cost"
                        : "project-cost d-flex justify-content-end align-items-end"
                    }`}
                  >
                    <label>Project Cost</label>
                    <p>
                      {parseFloat(projectCost) !== 0
                        ? `₹ ${projectCost} Cr.`
                        : "N/A"}
                    </p>
                  </div>
                </div>
                <div
                  className={`${
                    isIssueListPhysicalProgress
                      ? "d-flex alignment-flags"
                      : "project-flags d-flex"
                  } ${isFlagListPhysicalProgress ? "m-0" : ""}`}
                >
                  <Pragati
                    className={"pragati-review"}
                    isValidProject={get(issueDetails, "project.pragatiReview")}
                  />
                  {/* <PragatiPipeline
                    className={'pragati-review'}
                    isValidProject={get(
                      issueDetails,
                      'project.pragatiPipeline'
                    )}
                  /> */}
                  <PragatiPipeline
                    className={"pragati-review"}
                    isValidProject={
                      !get(issueDetails, "project.pragatiReview") &&
                      get(issueDetails, "project.pragatiPipeline")
                    }
                  />
                  <Nip
                    className={"pragati-review"}
                    isValidProject={get(issueDetails, "project.nipReview")}
                  />
                  <PmFoundationStone
                    className={"pragati-review"}
                    isValidProject={get(
                      issueDetails,
                      "project.pmFoundationStone"
                    )}
                  />
                  <CmPragatiYatra
                    className={"pragati-review"}
                    isValidProject={get(issueDetails, "project.cmPragatiYatra")}
                  />
                  <CmFoundationStone
                    className={"pragati-review"}
                    isValidProject={get(
                      issueDetails,
                      "project.cmFoundationStone"
                    )}
                  />

                  <PmgsHipimage
                    className={"pragati-review"}
                    isValidProject={get(issueDetails, "project.pmgsHip")}
                  />
                  <Pli
                    className={"pragati-review"}
                    isValidProject={get(issueDetails, "project.pli")}
                  />
                  <March24
                    className={"pragati-review"}
                    isValidProject={get(issueDetails, "project.march24")}
                  />
                  <PmGatiShakti
                    className={"pragati-review"}
                    isValidProject={get(
                      issueDetails,
                      "project.pmGatiShaktiNew"
                    )}
                  />
                </div>
              </div>
            </div>
          </div>

          <DisplayByPermission display={show}>
            <div className="edit-issue">
              <EditIssue
                issueId={get(issueDetails, "id")}
                show={show}
                handleClose={this.handleClose}
                callApiOnSuccess={callApiOnSuccess}
                workflowType={get(issueDetails, "project.workflowType")}
                projectPPList={get(issueDetails, "project.projectPPList")}
                isProposalValidated={this.state.isProposalValidated}
                handleProposalChange={this.handleProposalChange}
              />
            </div>
          </DisplayByPermission>

          <DisplayByPermission display={issueHistory}>
            <div className="history-activity issue-history-scroll-date">
              <div className="close-history">
                <div onClick={this.onToogleProgressTimeLine}>X</div>
              </div>
              <div className="history-activity-head">
                <ComponentLoader
                  isLoading={isHistoryLoading === STATUS.LOADING}
                />
                {["comment", "history"].map((value, index) => (
                  <h2
                    className={`ah-heading ${type === value && "active"}`}
                    onClick={e => {
                      this.toggleIssueHistory(e, value);
                    }}
                    key={`title-${index}`}
                  >
                    {(value === "history" && "Updates") || "Comments"}
                  </h2>
                ))}
              </div>
              {type === "history" ? (
                <HistoryAndCommentLoader
                  animationEnded={animationEnded}
                  isLoading={isHistoryLoading}
                  data={history}
                />
              ) : (
                <Comment
                  animationEnded={animationEnded}
                  isLoading={isHistoryLoading}
                  data={comment}
                  getAllComments={this.fetchIssueHistory}
                />
              )}
            </div>
          </DisplayByPermission>

          <DisplayByPermission display={issueHistoryResponsive}>
            <HistoryAndCommentModal
              closeModal={this.onToogleProgressTimeLineResponsive}
              isHistoryLoading={isHistoryLoading}
              toggleIssueHistory={this.toggleIssueHistory}
              getAllComments={this.fetchIssueHistory}
              animationEnded={animationEnded}
              history={history}
              comment={comment}
              type={type}
              show={issueHistoryResponsive}
            />
          </DisplayByPermission>
          <DisplayByPermission display={isPariveshModalVisible}>
            <PariveshData
              show={isPariveshModalVisible}
              closeModal={this.closePariveshModal}
              issueSubCategoryId={this.state.selectedIssueSubCategoryId}
              proposalNoParivesh={this.state.selectedProposalNoParivesh}
            />
          </DisplayByPermission>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    isApiLoading: state.issueActionReducer.isApiLoading,
    issueData: state.issueDetailsReducer.issueData
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      issueActivityHistoryDispatch: issueActivityHistory,
      issueActivityCommentDispatch: issueActivityComment,
      getActionsDispatch: getActions,
      getIssueListDispatch: getIssueList
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(IssueTile)
);
